import { useMemo } from 'react';

export function useMap<T, R>(transform: (from: T) => R, original: T[]) {
  return useMemo(
    () => original.map(transform),
    // eslint-disable-next-line
    [original]
  );
}
